'use client';
import { getQueryClient } from '@omnicomm/shared';
import { QueryClientProvider } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';

export default function Provider({ children }: PropsWithChildren) {
  const client = getQueryClient();
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
